import { jsonGet, jsonPost, jsonPut, jsonDelete } from "../api.js";

// Saved panels (CRUD)
export const getPanels = async () => jsonGet("panels");
export const getPanel = async (id) => jsonGet(`panels/${id}`);
export const createPanel = async (data) => jsonPost("panels", data);
export const updatePanel = async (id, data) => jsonPut(`panels/${id}`, data);
export const deletePanel = async (id) => jsonDelete(`panels/${id}`);

// Pre-flight cost estimate for an unsaved (draft) panel
export const estimatePanel = async (data) => jsonPost("panels/estimate", data);

// Panel chat sessions
export const getPanelSessions = async () => jsonGet("panel-sessions");
export const createPanelSession = async (data) =>
  jsonPost("panel-sessions", data);
export const deletePanelSession = async (id) =>
  jsonDelete(`panel-sessions/${id}`);
export const getPanelTurns = async (sessionId) =>
  jsonGet(`panel-sessions/${sessionId}/turns`);
export const sendPanelMessage = async (sessionId, question) =>
  jsonPost(`panel-sessions/${sessionId}/turns`, { question });
